import { useState } from "react";
import { Card, Group, Stack, Text } from "@/components/ui";
import type { AdminAuditEntry } from "../services/auditoria-service";
import { AccionBadge } from "./AccionBadge";
import { CategoriaBadge } from "./CategoriaBadge";
import { DetallesAmigables } from "./DetallesAmigables";

export function CambioMobileCard({ entry }: { entry: AdminAuditEntry }) {
  const [verDetalles, setVerDetalles] = useState(false);
  return (
    <Card padding="md">
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start" className="flex-nowrap">
          <div className="min-w-0 flex-1">
            <Text size="xs" c="dimmed">
              {new Date(entry.ocurridoAt).toLocaleString()}
            </Text>
            <Text fw={500} truncate className="mt-0.5">
              {entry.entidadDescripcion}
            </Text>
            <Group gap={4} className="mt-1 flex-wrap">
              <CategoriaBadge categoria={entry.categoria} />
              <AccionBadge accion={entry.accion} />
            </Group>
          </div>
        </Group>
        <Text size="xs" c="dimmed">
          Por <span className="font-mono text-[11px]">{entry.usuarioEmail ?? entry.usuarioId.slice(0, 8) + "…"}</span>
        </Text>
        <button
          type="button"
          onClick={() => setVerDetalles((v) => !v)}
          className="cursor-pointer self-start text-xs text-multiva-600 hover:underline"
        >
          {verDetalles ? "Ocultar detalles" : "Ver detalles"}
        </button>
        {verDetalles ? (
          <div className="rounded-md border border-border bg-muted/40 p-2">
            <DetallesAmigables detallesJson={entry.detallesJson} density="compacto" />
          </div>
        ) : null}
      </Stack>
    </Card>
  );
}
